import { render, staticRenderFns } from "./add_new_tariff_cost.vue?vue&type=template&id=a17a7c42&scoped=true&"
import script from "./add_new_tariff_cost.vue?vue&type=script&lang=js&"
export * from "./add_new_tariff_cost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17a7c42",
  null
  
)

/* custom blocks */
import block0 from "@/lang/actions.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Famo_licenses%2Felements%2Fadd_new_tariff_cost.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports